import React from "react";
import { useLocation } from "react-router-dom";
import { useObserver, useLocalStore } from "mobx-react-lite";
import { Grid, Container, useMediaQuery } from "@material-ui/core";
import { useTheme, makeStyles } from "@material-ui/core/styles";
import Header from "./Header";
import Navigation from "./Navigation";

const useStyles = makeStyles((theme) => ({
  main: {
    padding: theme.spacing(2),
  },
}));

type Props = {
  menus?: React.ComponentProps<typeof Navigation>["menus"];
  children: React.ReactNode;
};

export default ({ menus, children }: Props) => {
  const location = useLocation();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const styles = useStyles();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const store = useLocalStore(() => ({
    drawer: false,
    open() {
      this.drawer = true;
    },
    close() {
      this.drawer = false;
    },
  }));

  return useObserver(() => (
    <Grid container>
      {menus && (
        <Grid item md={2}>
          <Navigation
            menus={menus}
            DrawerProps={
              md
                ? { variant: "permanent" }
                : {
                    variant: "temporary",
                    open: store.drawer,
                    onClose: store.close,
                  }
            }
          />
        </Grid>
      )}
      <Grid item xs={12} md={menus ? 10 : 12}>
        <Header
          hamburger={menus && !md ? { onClick: store.open } : undefined}
        />
        <Container className={styles.main} component="main" maxWidth="xl">
          {children}
        </Container>
      </Grid>
    </Grid>
  ));
};
